/*
 * File: OrderNotesPanels.js
 * Project: mp-mobile-app
 *
 * Created by Jennifer Loecker on 08/21/2019
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Creates an expansion panel for each order note
 */

import React from "react";
import OrderNoteList from "./OrderNoteList";
import UIPanelGroup from "components/ui/UIPanelGroup";
import PropTypes from "prop-types";
import { List } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  panelPadding: {
    marginTop: theme.spacing(1),
    marginLeft: theme.spacing(2.5),
    marginRight: theme.spacing(2.5)
  }
});

const OrderNotesPanels = ({ classes, order }) => {
  let panels = [];
  const OrderNotesPanel = () => (
    <List>
      <OrderNoteList order={order} />
    </List>
  );

  panels.push({
    title: "Status Updates and Notes ",
    content: OrderNotesPanel
  });

  return <UIPanelGroup containerClass={classes.panelPadding} panels={panels} />;
};

OrderNotesPanels.propTypes = {
  order: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(OrderNotesPanels);
